// src/utils/authHelpers.js

/**
 * Returns a friendly display name for both native Cognito users
 * and federated (Microsoft Entra ID) users.
 *
 * Federated usernames look like "MicrosoftEntraSAML_abc123..." which
 * is not user-friendly, so we fall back to attributes or email.
 */
export function getDisplayName(user) {
  const attrs = user.attributes || {};

  // Prefer given + family name (SAML often sets "name" to the email address)
  if (attrs.given_name && attrs.family_name)
    return `${attrs.given_name} ${attrs.family_name}`;
  if (attrs.name && !attrs.name.includes("@")) return attrs.name;
  if (attrs.email) return attrs.email;

  const username = user.username || "";
  // Federated usernames are "ProviderName_sub" — strip the provider prefix
  if (username.includes("_")) return username.split("_").slice(1).join("_");

  return username;
}

/**
 * Returns true if the user signed in via a federated identity provider.
 */
export function isFederatedUser(user) {
  const username = user.username || "";
  return username.startsWith("MicrosoftEntraSAML_") || username.includes("_");
}

/**
 * Pulls the audit-trail identity fields out of a Cognito user. `sub` is the
 * stable UUID that never changes even if email/name is updated.
 */
export function getUserIdentity(user) {
  const attrs = user?.attributes || {};
  return {
    name: getDisplayName(user),
    email: attrs.email || "",
    sub: attrs.sub || user?.username || "",
  };
}
